

















































import { Component, Vue } from 'vue-property-decorator';
import localforage from 'localforage';

interface Announcement {
  lastShow: Date;
}

@Component
export default class extends Vue {
  private overlay = false;

  mounted() {
    localforage
      .getItem<Announcement>('announcement')
      .then(val => {
        const dateStr = val && val.lastShow ? val.lastShow : new Date();
        const lastshowDay = new Date(dateStr);
        lastshowDay.setHours(0, 0, 0, 0);
        if (Date.now() - lastshowDay.getTime() >= 24 * 60 * 60 * 1000) {
          this.overlay = true;
          this.setLastshow();
        }
      })
      .catch(() => {
        this.overlay = true;
        this.setLastshow();
      });
  }

  private async setLastshow() {
    try {
      await localforage.setItem<Announcement>('announcement', {
        lastShow: new Date(),
      });
    } catch (error) {
      console.log(error);
    }
  }
}
